import { parseValidationErrors } from "@/lib/api";

import type { AccionesDelFormulario, ComentarioValues } from "./FormularioDeComentario";

/** Los únicos campos que el formulario puede pintar. */
const CAMPOS: (keyof ComentarioValues)[] = ["modulo", "tipo", "texto"];

/**
 * Pega en cada campo el mensaje que devolvió un 422 y avisa si pudo hacerlo.
 *
 * Devuelve `false` cuando el error NO es un 422 con errores de campo —un 403,
 * un 500, la red caída—: ahí el llamador tiene que mostrar un toast, porque
 * no hay campo donde escribir la explicación. Sin ese `false`, un 403 de "no
 * es tuyo" desaparecería en silencio y el diálogo se quedaría abierto sin
 * decir nada.
 *
 * Vive suelto porque el alta y la edición lo necesitan igual, y dos copias de
 * este mapeo son una que un día se olvida de un campo.
 */
export function aplicarErroresDeComentario(
  error: unknown,
  acciones: AccionesDelFormulario,
): boolean {
  const errores = parseValidationErrors(error);
  if (!errores) return false;

  let alguno = false;
  for (const campo of CAMPOS) {
    const mensaje = errores[campo];
    if (mensaje) {
      acciones.errorDeCampo(campo, mensaje);
      alguno = true;
    }
  }

  // Un 422 cuyos errores son de OTROS campos (uno que la pantalla no dibuja)
  // tampoco se puede mostrar en el formulario: que lo tome el toast.
  return alguno;
}
